(function stationApiForm() {
  var forms = document.querySelectorAll('[data-station-api-form]');
  if (!forms.length) return;

  var turnstileScriptPromise;

  function trim(value) {
    return String(value == null ? '' : value).trim();
  }

  function normalizeBaseUrl(url) {
    var value = trim(url);
    if (!value) return '';
    return value.replace(/\/$/, '');
  }

  function joinUrl(baseUrl, endpoint) {
    var base = normalizeBaseUrl(baseUrl);
    var path = trim(endpoint || '');
    if (!base || !path) return '';
    return base + (path.charAt(0) === '/' ? path : '/' + path);
  }

  function setStatus(form, message, state) {
    var node = form.querySelector('[data-station-api-status]');
    if (!node) return;
    node.textContent = message || '';
    node.dataset.state = state || 'idle';
  }

  function ensureTurnstileScript() {
    if (window.turnstile && typeof window.turnstile.render === 'function') {
      return Promise.resolve();
    }

    if (turnstileScriptPromise) return turnstileScriptPromise;

    turnstileScriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-station-turnstile-script]');
      if (existing) {
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', function () {
          reject(new Error('Failed to load Turnstile script.'));
        });
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.dataset.stationTurnstileScript = 'true';
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Failed to load Turnstile script.'));
      };
      document.head.appendChild(script);
    });

    return turnstileScriptPromise;
  }

  function ensureTurnstileWidget(form) {
    if (form.dataset.stationTurnstileReady === 'true') {
      return Promise.resolve(true);
    }

    var siteKey = trim(form.dataset.stationTurnstileSiteKey);
    var container = form.querySelector('[data-station-turnstile]');
    if (!siteKey || !container) {
      return Promise.resolve(false);
    }

    return ensureTurnstileScript()
      .then(function () {
        if (!window.turnstile || typeof window.turnstile.render !== 'function') {
          throw new Error('Turnstile not available.');
        }

        var widgetId = window.turnstile.render(container, {
          sitekey: siteKey,
          responseFieldName: 'cf-turnstile-response',
        });

        form.dataset.stationTurnstileWidgetId = String(widgetId);
        form.dataset.stationTurnstileReady = 'true';
        return true;
      })
      .catch(function () {
        setStatus(form, 'Security challenge failed to load. Please refresh and try again.', 'error');
        return false;
      });
  }

  function resetTurnstileWidget(form) {
    var widgetId = form.dataset.stationTurnstileWidgetId;
    if (!widgetId) return;
    if (!window.turnstile || typeof window.turnstile.reset !== 'function') return;
    window.turnstile.reset(widgetId);
  }

  function getTurnstileToken(form) {
    var input = form.querySelector('input[name="cf-turnstile-response"]');
    return trim(input && input.value);
  }

  function serializeForm(form) {
    var payload = {};
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      payload[key] = typeof value === 'string' ? value.trim() : value;
    });
    return payload;
  }

  function primeTurnstile(form) {
    var activate = function () {
      ensureTurnstileWidget(form);
    };

    form.addEventListener('focusin', activate, { once: true });
    form.addEventListener('pointerdown', activate, { once: true });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            ensureTurnstileWidget(form);
          });
        },
        { rootMargin: '120px 0px 120px 0px' },
      );
      observer.observe(form);
    }
  }

  forms.forEach(function (form) {
    primeTurnstile(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var baseUrl = form.dataset.stationApiUrl || '';
      var endpoint = form.dataset.stationApiEndpoint || '';
      var url = joinUrl(baseUrl, endpoint);
      if (!url) {
        setStatus(form, 'Submission endpoint is not configured. Please contact support.', 'error');
        return;
      }

      var submitButton = form.querySelector('[data-station-api-submit]') || form.querySelector('button[type="submit"]');
      var loadingText = trim(form.dataset.stationSubmittingMessage) || 'Submitting...';
      var successMessage = trim(form.dataset.stationSuccessMessage) || 'Submitted successfully.';
      var fallbackError = trim(form.dataset.stationErrorMessage) || 'Submission failed. Please try again.';
      var defaultButtonLabel = submitButton ? submitButton.textContent : '';

      setStatus(form, '', 'idle');

      Promise.resolve()
        .then(function () {
          return ensureTurnstileWidget(form);
        })
        .then(function (ready) {
          if (!ready) {
            throw new Error('Security challenge is unavailable.');
          }

          var token = getTurnstileToken(form);
          if (!token) {
            throw new Error('Please complete the security challenge and try again.');
          }

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-busy', 'true');
            submitButton.textContent = loadingText;
          }

          var payload = serializeForm(form);
          payload['cf-turnstile-response'] = token;

          return fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
        })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              return { response: response, body: body };
            });
        })
        .then(function (result) {
          var response = result.response;
          var body = result.body || {};
          if (!response.ok || body.success !== true) {
            var message =
              (body.error && body.error.message) || body.message || fallbackError;
            throw new Error(message);
          }

          setStatus(form, body.message || successMessage, 'success');
          form.reset();
          resetTurnstileWidget(form);
        })
        .catch(function (error) {
          setStatus(form, error.message || fallbackError, 'error');
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.textContent = defaultButtonLabel;
          }
        });
    });
  });
})();
